import { render, staticRenderFns } from "./details_work_canada.vue?vue&type=template&id=1e35532a&"
import script from "./details_work_canada.vue?vue&type=script&lang=js&"
export * from "./details_work_canada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports